export const capitalize = s => {
    return s && s[0].toUpperCase() + s.slice(1);
};
